import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const t = i(
  (o, s) => /* @__PURE__ */ e.jsx(
    l,
    {
      ref: s,
      ...o,
      image: (r) => /* @__PURE__ */ e.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 32,
          height: 32,
          fill: "none",
          viewBox: "0 0 32 32",
          ...r,
          children: /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M9.334 5.993C7.89 7.533 7 9.873 7 13c0 6.239 1.436 10.132 3.206 12.418C11.953 27.674 14.12 28.5 16 28.5s4.047-.826 5.794-3.082C23.564 23.132 25 19.238 25 13c0-3.128-.89-5.466-2.334-7.007C21.238 4.47 19.056 3.5 16 3.5s-5.238.97-6.666 2.493m16.668 15.184c.564-2.005.918-4.381.986-7.175 3.015.1 2.605 4.984-.986 7.175m-20.99-7.175c.068 2.794.422 5.17.986 7.175-3.591-2.191-4.001-7.075-.986-7.175",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
t.displayName = "FaceIcon";
export {
  t as FaceIcon,
  t as default
};
//# sourceMappingURL=index.js.map
